import "./ImageGallerieStyles.scss";
import { IJSLComponent, IJSLVNode, JSLRender, refresh } from "jsl-render";
import { LoadingComponent } from "jsl-ui";
import { isInRole } from "../../../helper/ajax";
import { AdminController } from "../../../ajax/AdminController";
import { PublicController } from "../../../ajax/PublicController";

export class ImageGallerieComponent implements IJSLComponent {

    public State = { count: undefined };

    constructor(private ids: string[], private initialShowCount?: number) {
    }

    // public onCreate() {
    //     if (this.Status.count === undefined) {
    //         this.Status.count = this.initialShowCount;
    //     }
    // }

    public render(): IJSLVNode {
        let showIds = this.ids;
        const currentCount = this.State.count ?? this.initialShowCount ?? this.ids.length;
        if (currentCount < this.ids.length) {
            showIds = showIds.slice(0, currentCount);
        }
        return <div class="img-gal-comp">
            {showIds.map((id, idx) =>
                <div>
                    <img data-id={id} click={() => {
                        this.enlarge(idx);
                    }} src={"/Home/Thumbnail/" + id} />
                </div>
            )}
             {currentCount < this.ids.length ? <div>
                    <button class="genric-btn" click={() => {
                        this.State.count = this.ids.length;
                    }}>alle Bilder zeigen</button>
            </div> : undefined}
        </div>;
    }

    public isEqual(node: IJSLComponent): boolean {
        return (this as any).__proto__ === (node as any).__proto__;
    }

    private enlarge(idx: number): boolean {
        const src: string = "/Home/Thumbnail/" + this.ids[idx];
        const largediv = document.createElement("div");
        const largeImg = document.createElement("img");

        const left = document.createElement("span");
        left.className = "nav-btn";
        left.innerHTML = "<img style='width:40px' src='/img/left.png' alt='<' />";
        left.style.marginRight = "-42px";
        left.addEventListener("click", (e) => {
            e.stopPropagation();
            largediv.parentElement.removeChild(largediv);
            this.enlarge(idx - 1);
        });

        const right = document.createElement("span");
        right.className = "nav-btn";
        right.innerHTML = "<img style='width:40px' src='/img/right.png' alt='>' />";
        right.style.marginLeft = "-42px";
        right.addEventListener("click", (e) => {
            e.stopPropagation();
            largediv.parentElement.removeChild(largediv);
            this.enlarge(idx + 1);
        });

        largeImg.onload = () => {
            if (largeImg.complete) {
                largediv.removeChild(largediv.firstElementChild); // remove loading
                if (idx > 0) {
                    largediv.appendChild(left);
                }
                largediv.appendChild(largeImg);
                if (idx < this.ids.length - 1) {
                    largediv.appendChild(right);
                }
                this.createButtons(largediv, this.ids[idx]);
            }
        };
        PublicController.GetCopyright({ id: this.ids[idx] }).then((c) => {
            if (c) {
                const cpdiv = document.createElement("div");
                cpdiv.textContent = "© " + c;
                cpdiv.className = "copyright-div";
                largediv.appendChild(cpdiv);
            }
        });
        new JSLRender(largediv).render(new LoadingComponent());
        largeImg.src = src.replace("Thumbnail", "Image");
        largeImg.style.maxHeight = "calc(100vh - 2rem)";
        largeImg.style.maxWidth = "calc(100vw - 2.6rem)";
        largeImg.style.zIndex = "5";
        largediv.style.position = "fixed";
        largediv.style.zIndex = "2200";
        largediv.style.top = "1px";
        largediv.style.right = "0";
        largediv.style.left = "0";
        largediv.style.height = "100vh";
        largediv.style.textAlign = "center";
        largediv.style.background = "#000000ee";
        largediv.style.paddingTop = "2rem";
        largediv.style.boxSizing = "border-box";
        document.querySelector("body").appendChild(largediv);
        largediv.addEventListener("click", () => {
            largediv.parentElement.removeChild(largediv);
        });


        return false;
    }

    private async createButtons(container: HTMLDivElement, id: string) {
        const close = document.createElement("button");
        close.innerText = "x";
        close.className = "close-btn genric-btn default-border";
        container.append(close);
        if (isInRole("admin") || ((window as any)._user && (await PublicController.GetUploader({ id }))?.toLowerCase() === (window as any)._user?.toLowerCase())) {
            const del = document.createElement("button");
            del.innerText = "löschen";
            del.className = "genric-btn default-border del-btn";
            del.addEventListener("click", () => {
                AdminController.DeleteImage({ id }).then(() => {
                    const imgs = document.querySelectorAll("img");
                    for (let i = 0; i < imgs.length; i++) {
                        if (imgs[i].getAttribute("data-id") === id) {
                            imgs[i].parentElement.removeChild(imgs[i]);
                            break;
                        }
                    }
                    refresh();
                });
            });
            container.append(del);
        }
    }
}
